import { useMediaQuery } from '@chakra-ui/react'
import * as React from 'react'
import { SearchInitialValues, SortType } from 'types'

type AppContextType = {
  drawerOpen: boolean
  searchFilters: SearchInitialValues
  sortType: SortType
  setSortType: React.Dispatch<React.SetStateAction<SortType>>
  toggleDrawer: () => void
  isTabletOrMobile: boolean
  secondaryDrawerOpen: boolean
  toggleSecondaryDrawer: (val?: boolean) => void
  setsearchFilters: React.Dispatch<React.SetStateAction<SearchInitialValues>>
  isAdminMode: boolean
  setIsAdminMode: React.Dispatch<React.SetStateAction<boolean>>
  previewComponent: React.ReactNode
  setPreviewComponent: React.Dispatch<React.SetStateAction<React.ReactNode>>
}
export const initialValues = {
  propertyTypes: [],
  minPrice: '',
  maxPrice: '',
  furnished: null,
  search: '',
  selectedArea: [],
  bedRooms: '',
  bathRooms: '',
  rentalTerms: [],
  propertyAvailabilities: ''
}

export const AppContext = React.createContext<AppContextType>({
  drawerOpen: false,
  searchFilters: initialValues,
  sortType: 'updated_at:desc',
  setSortType: () => null,
  isTabletOrMobile: false,
  secondaryDrawerOpen: false,
  toggleSecondaryDrawer: () => null,
  setsearchFilters: () => null,
  toggleDrawer: () => null,
  isAdminMode: false,
  setIsAdminMode: () => null,
  previewComponent: null,
  setPreviewComponent: () => null
})

export const useAppContext = (): AppContextType => React.useContext(AppContext)

const AppProvider: React.FC<{}> = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false)
  const [isTabletOrMobile] = useMediaQuery('(max-width: 50em)')
  const [secondaryDrawerOpen, setSecondaryDrawerOpen] = React.useState(
    isTabletOrMobile ? false : true
  )
  const [sortType, setSortType] = React.useState<SortType>('updated_at:desc')
  const [searchFilters, setsearchFilters] = React.useState<SearchInitialValues>(initialValues)
  const [isAdminMode, setIsAdminMode] = React.useState(false)
  const [previewComponent, setPreviewComponent] = React.useState<React.ReactNode>(null)

  function toggleDrawer() {
    setDrawerOpen(!drawerOpen)
  }
  function toggleSecondaryDrawer(val?: boolean) {
    setSecondaryDrawerOpen(val ? val : !secondaryDrawerOpen)
  }

  return (
    <AppContext.Provider
      value={{
        drawerOpen,
        toggleDrawer,
        searchFilters,
        setsearchFilters,
        sortType,
        setSortType,
        isAdminMode,
        setIsAdminMode,
        isTabletOrMobile,
        secondaryDrawerOpen,
        toggleSecondaryDrawer,
        previewComponent,
        setPreviewComponent
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export default AppProvider
